module.exports = __webpack_public_path__ + "static/img/06.e22ed93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/junActivitySpecialty2/06.png
// module id = SK99
// module chunks = 0